module.exports = __webpack_public_path__ + "img/Quiz.c1ac0d13.png";